import script from "./Catalog.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./Catalog.vue?vue&type=script&setup=true&lang=js"
export * from "./Catalog.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./Catalog.vue?vue&type=script&setup=true&lang=js"

import "./Catalog.vue.scss?vue&type=style&index=0&id=1ae49f9c&lang=scss&scoped=true!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./Catalog.vue?vue&type=style&index=0&id=1ae49f9c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ae49f9c"]])

export default __exports__